import React from "react";
import { useBundleContext } from "./BundleContext";

export const BundleTitle = () => {
  const { bundle } = useBundleContext();
  return <h3 className="title font-normal">{bundle.title}</h3>;
};
